export const POSTTYPES: {[key:string] : string } = {
    STANDARD: 'Novedad',
    OFFER: 'Oferta',
    EVENT: 'Evento',   
  }